import { LitElement, html } from 'lit';
import { property } from 'lit/decorators.js';
import { guardedCustomElement } from '../utils/guarded-custom-element';
import { styles } from './sds-details.styles';
import '../sds-icon/sds-icon';
import { SDSEventDispatcherMixin } from '../mixins/sds-event-dispatcher-mixin';

export interface SDSDetailsProps {
	open?: boolean;
	standalone?: boolean;
	name?: string;
}

@guardedCustomElement('sds-details')
export class SDSDetails extends SDSEventDispatcherMixin(LitElement) {
	static override styles = [styles];

	@property({ type: Boolean, reflect: true })
	open: SDSDetailsProps['open'] = false;

	@property({ type: Boolean, reflect: true })
	standalone: SDSDetailsProps['standalone'] = false;

	@property({ type: String, reflect: true })
	name: SDSDetailsProps['name'] = undefined;

	private _handleToggle = (event: Event) => {
		const details = event.currentTarget as HTMLDetailsElement;
		if (this.open !== details.open) {
			this.open = details.open;
		}

		this.dispatchSheriffEvent('sds-toggle', { open: details.open });
	};

	override render() {
		return html`
			<details class="sds-details" .name="${this.name ?? ''}" ?data-standalone="${this.standalone}" ?open="${this.open}" @toggle="${this._handleToggle}">
				<summary class="sds-details__summary">
					<sds-icon name="chevron_up-material-filled"></sds-icon>
					<div class="sds-details__summary-content">
						<slot name="summary"></slot>
					</div>
				</summary>
				<div class="sds-details__content">
					<slot></slot>
				</div>
			</details>
		`;
	}
}

declare global {
	interface HTMLElementTagNameMap {
		'sds-details': SDSDetails;
	}
}
